import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "tc" }
const _hoisted_2 = { class: "tc__head" }
const _hoisted_3 = { class: "tc__label-wrap" }
const _hoisted_4 = {
  class: "tc__help",
  tabindex: "0",
  "aria-label": "规则说明"
}
const _hoisted_5 = ["disabled"]
const _hoisted_6 = {
  key: 0,
  class: "tc__empty"
}
const _hoisted_7 = {
  key: 0,
  class: "tc__loading"
}
const _hoisted_8 = {
  key: 1,
  class: "tc__empty"
}
const _hoisted_9 = {
  key: 2,
  class: "tc__tasks"
}
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "tc__task-title" }
const _hoisted_12 = {
  key: 0,
  class: "tc__task-progress"
}
const _hoisted_13 = { class: "tc__task-progress-bar" }
const _hoisted_14 = { class: "tc__task-meta" }
const _hoisted_15 = {
  key: 1,
  class: "tc__task-refund"
}
const _hoisted_16 = {
  key: 2,
  class: "tc__task-error"
}
const _hoisted_17 = {
  key: 3,
  class: "tc__task-error"
}
const _hoisted_18 = {
  key: 4,
  class: "tc__task-downloads"
}
const _hoisted_19 = ["disabled", "onClick"]
const _hoisted_20 = ["disabled", "onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Help = _resolveComponent("Help")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, [
        _cache[2] || (_cache[2] = _createElementVNode("span", { class: "tc__label" }, "任务中心", -1)),
        _createElementVNode("span", _hoisted_4, [
          _createVNode(_component_Help, {
            theme: "outline",
            size: "14",
            fill: "currentColor",
            strokeWidth: "2"
          }),
          _cache[1] || (_cache[1] = _createElementVNode("span", { class: "tc__help-tip" }, "源文件和成品最多保留 30 天，到期后任务过期；源文件下载链接 24 小时内有效，成品 7 天内有效。每页处理耗时视页数和内容而定，通常在十几分钟内；失败或超时未完成的页面自动退还额度。", -1))
        ])
      ]),
      (_ctx.store.session)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: "tc__refresh",
            disabled: _ctx.store.loadingTasks,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.store.loadTasks()))
          }, _toDisplayString(_ctx.store.loadingTasks ? '刷新中...' : '刷新'), 9, _hoisted_5))
        : _createCommentVNode("", true)
    ]),
    (!_ctx.store.session)
      ? (_openBlock(), _createElementBlock("p", _hoisted_6, "登录后可查看任务进度和下载成品。"))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (_ctx.store.loadingTasks && _ctx.store.tasks.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, "加载中..."))
            : (_ctx.store.tasks.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, "还没有任务。上传源文件后在这里查看进度。"))
              : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.store.tasks, (task) => {
                    return (_openBlock(), _createElementBlock("article", {
                      key: task.id,
                      class: _normalizeClass(['tc__task', { 'tc__task--active': _ctx.store.activeTask?.task.id === task.id }])
                    }, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "tc__task-main",
                        onClick: ($event: any) => (_ctx.store.selectTask(task.id))
                      }, [
                        _createElementVNode("span", _hoisted_11, _toDisplayString(task.title || '图转 PPT'), 1),
                        _createElementVNode("span", {
                          class: _normalizeClass(['tc__task-status', `tc__task-status--${_ctx.taskView(task).status}`])
                        }, _toDisplayString(_ctx.formatStatus(_ctx.taskView(task).status)), 3)
                      ], 8, _hoisted_10),
                      (_ctx.isProcessing(_ctx.taskView(task)))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                            _createElementVNode("div", _hoisted_13, [
                              _createElementVNode("div", {
                                class: "tc__task-progress-fill",
                                style: _normalizeStyle({ width: `${_ctx.progressPercent(_ctx.taskView(task))}%` })
                              }, null, 4)
                            ]),
                            _createElementVNode("span", null, _toDisplayString(_ctx.progressPercent(_ctx.taskView(task))) + "% · " + _toDisplayString(_ctx.taskView(task).current_stage || '等待处理'), 1)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("dl", _hoisted_14, [
                        _createElementVNode("div", null, [
                          _cache[3] || (_cache[3] = _createElementVNode("dt", null, "任务时间", -1)),
                          _createElementVNode("dd", null, _toDisplayString(_ctx.formatDateTime(task.created_at)), 1)
                        ]),
                        _createElementVNode("div", null, [
                          _cache[4] || (_cache[4] = _createElementVNode("dt", null, "执行耗时", -1)),
                          _createElementVNode("dd", null, _toDisplayString(_ctx.formatDuration(_ctx.taskDurationMs(_ctx.taskView(task)))), 1)
                        ]),
                        _createElementVNode("div", null, [
                          _cache[5] || (_cache[5] = _createElementVNode("dt", null, "耗费额度", -1)),
                          _createElementVNode("dd", null, _toDisplayString(_ctx.spentPoints(_ctx.taskView(task))) + " / " + _toDisplayString(_ctx.taskView(task).cost_points || 0), 1)
                        ])
                      ]),
                      ((_ctx.taskView(task).refunded_pages ?? 0) > 0)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_15, "已退还 " + _toDisplayString(_ctx.taskView(task).refunded_pages) + " 额度", 1))
                        : _createCommentVNode("", true),
                      (_ctx.qualityFailureText(_ctx.taskView(task)))
                        ? (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString(_ctx.qualityFailureText(_ctx.taskView(task))), 1))
                        : (_ctx.taskView(task).status === 'failed')
                          ? (_openBlock(), _createElementBlock("p", _hoisted_17, _toDisplayString(_ctx.taskView(task).error_public || '处理失败，未完成页面已退还额度'), 1))
                          : _createCommentVNode("", true),
                      (_ctx.downloadArtifacts(task).length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.downloadArtifacts(task), (artifact) => {
                              return (_openBlock(), _createElementBlock("button", {
                                key: artifact.id,
                                type: "button",
                                class: "tc__download-link",
                                disabled: _ctx.downloadingTaskId === task.id,
                                onClick: ($event: any) => (_ctx.downloadArtifact(artifact, task.id))
                              }, _toDisplayString(_ctx.downloadingTaskId === task.id ? '下载中...' : '下载 PPTX'), 9, _hoisted_19))
                            }), 128))
                          ]))
                        : (_ctx.isDownloadable(_ctx.taskView(task)))
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 5,
                              type: "button",
                              class: "tc__download-link tc__download-link--button",
                              disabled: _ctx.downloadingTaskId === task.id,
                              onClick: ($event: any) => (_ctx.downloadTaskPptx(task))
                            }, _toDisplayString(_ctx.downloadingTaskId === task.id ? '下载中...' : '下载 PPTX'), 9, _hoisted_20))
                          : _createCommentVNode("", true)
                    ], 2))
                  }), 128))
                ]))
        ], 64))
  ]))
}